import localforage from "localforage";

const Session = {
    clear() {
        window.$cookies.remove("access_token_ibk");
        window.$cookies.remove("refresh_token_ibk");
        window.$cookies.remove("idleTimeoutIbk");
        window.$cookies.remove("longitudeIbk");
        window.$cookies.remove("latitudeIbk");
        window.$cookies.remove("userAgentIbk");
        localforage.removeItem("userDetailIbk");
    },
    userDetail() {
        return localforage.getItem("userDetailIbk")
    }
}

export const SessionPlugin =  {
    install(Vue) {
        Vue.prototype.$session = Session
    }
}

export default Session